const calculateMonthlyPayment = (principal: number, monthlyInterestRate: number, termInMonths: number) => {
    const i = monthlyInterestRate / 100;

    const numerator = i * Math.pow(1 + i, termInMonths);
    const denominator = Math.pow(1 + i, termInMonths) - 1;

    if (denominator === 0) {
        throw new Error("Loan term cannot be zero.");
    }

    const monthlyPayment = principal * (numerator / denominator);
    return Number(monthlyPayment.toFixed(0));
};

const capitalizeFirstLetters = (str: string) => {
    const words = str.split(" ");
    const capitalizedWords = words.map((word) => {
        if (word.length > 0) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word; // Keep empty words as they are
    });
    const result = capitalizedWords.join(" ");
    return result;
};

function removeDuplicatesByKey(arr: Array<any>, key: string) {
    // Utilizamos un objeto (hash map) para rastrear los IDs que ya hemos visto.
    const map = new Map();

    return arr.filter((item) => {
        const keyValue = item[key];

        // Si la clave NO está en el mapa, es un ítem único.
        if (!map.has(keyValue)) {
            // Lo añadimos al mapa y devolvemos true para mantenerlo.
            map.set(keyValue, true);
            return true;
        }

        // Si la clave SÍ está en el mapa, es un duplicado, devolvemos false para filtrarlo.
        return false;
    });
}

export default { calculateMonthlyPayment, capitalizeFirstLetters, removeDuplicatesByKey };
